import React, {ReactElement} from 'react';
import Typography from '@material-ui/core/Typography';

type Props = {
  children: string;
};

function PageTitle({children}: Props): ReactElement {
  return (
    <Typography variant="h1" gutterBottom>
      {children}
    </Typography>
  );
}

export default PageTitle;
